import { AgentRuntimeProviderIdEnum, ChatProviderIdEnum, EmailProviderIdEnum, InAppProviderIdEnum, SmsProviderIdEnum, } from '../../types';
import { chatProviders, emailProviders, inAppProviders, pushProviders, smsProviders, toolProviders } from './channels';
export { chatProviders, emailProviders, inAppProviders, pushProviders, smsProviders, toolProviders, } from './channels';
export const providers = [
    ...emailProviders,
    ...smsProviders,
    ...chatProviders,
    ...pushProviders,
    ...inAppProviders,
    ...toolProviders,
];
export const NOVU_PROVIDERS = [
    InAppProviderIdEnum.Novu,
    SmsProviderIdEnum.Novu,
    EmailProviderIdEnum.Novu,
    EmailProviderIdEnum.NovuAgent,
    EmailProviderIdEnum.AgentEmailInbox,
    ChatProviderIdEnum.Novu,
    ChatProviderIdEnum.NovuWebChat,
    AgentRuntimeProviderIdEnum.NovuAnthropic,
];
export const NOVU_SMS_EMAIL_PROVIDERS = [SmsProviderIdEnum.Novu, EmailProviderIdEnum.Novu];
/**
 * Inbound agent inboxes that share the `{slug}-{routingKey}@domain` address.
 * `novu-email-agent` is the dashboard agent inbox. `agent-email-inbox` is Human-only.
 */
export const AGENT_INBOX_PROVIDER_IDS = [EmailProviderIdEnum.NovuAgent, EmailProviderIdEnum.AgentEmailInbox];
export function isAgentInboxProvider(providerId) {
    return AGENT_INBOX_PROVIDER_IDS.includes(providerId);
}
export const PROVIDER_ID_TO_CHANNEL_MAP = Object.fromEntries(providers.map((p) => [p.id, p.channel]));
//# sourceMappingURL=providers.js.map